import { motion } from 'framer-motion';

interface EmptyStateProps {
  icon: string;
  title: string;
  description: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <motion.div
      className="glass-card p-8 sm:p-12 text-center space-y-4"
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
    >
      <div className="text-5xl">{icon}</div>
      <div className="space-y-2">
        <h3 className="text-lg font-bold">{title}</h3>
        <p className="text-secondary">{description}</p>
      </div>
      {action && (
        <button className="btn btn--primary" onClick={action.onClick}>
          <span>{action.label}</span>
        </button>
      )}
    </motion.div>
  );
}
